import { AppContainer } from 'react-hot-loader'
import React from 'react'
import ReactDOM from 'react-dom'
import Routing from './routes'
import configureStore, { history } from './configureStore'
import { ProSidebarProvider } from 'react-pro-sidebar'
import CookieConsent from "react-cookie-consent";
require('./styles.css')

const store = configureStore()
const render = () => {
  ReactDOM.render(
    <AppContainer>
      <ProSidebarProvider store={store}>
        <Routing />
        <CookieConsent>
          This website uses cookies to enhance the user experience.
        </CookieConsent>
      </ProSidebarProvider>
    </AppContainer>,
    document.getElementById('react-root')
  )
}

render()

// Hot reloading
if (module.hot) {
  // Reload components
  module.hot.accept('./routes/index', () => {
    render()
  })
}
